import { connect } from "react-redux";

import View from "./View";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as actions from "src/bepaid/store/model/Fetch/actions";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";
const mapStateToProps = (state: RootState, props: any) => ({
  selectedPayment: selectors.getBepaidSelectedPaymentDetail(state),
  selectedScheduleDetail: selectors.getScheduleDetail(state)
});

const mapDispatchToProps = {
  toggleModal: actions.toggleModal
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
